import React from 'react';
import { Scale, Heart } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="backdrop-blur-xl bg-white/40 border-t border-white/20 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2 text-sky-500">
            <Scale size={20} strokeWidth={1.5} />
            <span className="font-light">Czen.fr</span>
          </div>
          
          <div className="text-slate-600 text-sm text-center md:text-right">
            <p>
              © 2025 Tous droits réservés - Propulsé par{' '}
              <a 
                href="https://woptimizer.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sky-500 hover:text-sky-600 transition-colors"
              >
                Woptimizer.com
              </a>
            </p>
            <p className="mt-1 flex items-center justify-center md:justify-end gap-1">
              Créé avec <Heart size={14} className="text-rose-500" /> pour la résolution pacifique des conflits
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;